// 年卡使用程度枚举（用于列表筛选与汇总卡片联动）
// 边界与后端 CardService::YEARLY_CARD_USED_SCOPE_* 保持一致
export const yearlyCardUsedScopes = {
  light: {
    value: 1,
    name: '轻度使用（1~5 次）',
  },
  heavy: {
    value: 2,
    name: '重度使用（≥200 次）',
  },
};

export function findYearlyCardUsedScope(value) {
  for (const key in yearlyCardUsedScopes) {
    if (value === yearlyCardUsedScopes[key].value) return [yearlyCardUsedScopes[key]];
  }
  return [];
}
